// extracted by mini-css-extract-plugin
export var AuthorAvatarContainer = "bk_dH";
export var AuthorBioContainer = "bk_dF";
export var AuthorContainer = "bk_dD";
export var AuthorGradientBackground = "bk_dG";
export var AuthorInfoContainer = "bk_dJ";
export var AuthorInfoDetails = "bk_dK";
export var AuthorInfoName = "bk_dL";
export var AuthorInfoSection = "bk_dM";
export var MuiPopperRoot = "bk_bX";
export var MuiTooltipPopper = "bk_bY";